import PropTypes from 'prop-types';
import { Modal } from 'antd';
import ContentMap from '../../../Calendar/components/servicesMap/components/ContentMap';
import { useDictionaryTranslation } from '../../../../hooks/useDictionaryTranslation';

export const ModalMap = ({ title, show, handleClose, coordsInfo }) => {
  const { translate: t } = useDictionaryTranslation();
  const closeModal = () => {
    handleClose();
  };

  return (
    <Modal
      title={t(title)??t('map')}
      destroyOnClose
      width="50%"
      height="20%"
      visible={show}
      onCancel={closeModal}
      footer={<div />}
      bodyStyle={{padding: '5px'}}
    >
      <ContentMap showOnlyInitialPosition onlyCoords={coordsInfo} />
    </Modal>
  );
};

ModalMap.propTypes = {
  title: PropTypes.string,
  show: PropTypes.bool,
  handleClose: PropTypes.func,
  coordsInfo: PropTypes.object,
};
